import { Component } from '@angular/core';

@Component({
  selector: 'app-base-grid-input',
  templateUrl: './base-grid-input.component.html',
  styleUrls: ['./base-grid-input.component.css'],
  standalone: false
})
export class BaseGridInputComponent {
  public params: any;

  constructor() {}

  public refresh(params: any): boolean {
    // assignment of data.RowId to grid row's data Id is set in the parent grid component
    const rowNode = params.api.getRowNode(params.data.RowId);

    if (params.data[params.colDef.field] != params.value) {
      rowNode.setDataValue(params.colDef.field, params.value);
    }

    return false;
  }
}
